// Generat automat din README.md
import React, { useState, useEffect } from 'react';
import { Bot, Play, Pause, Settings, Zap, Calendar, Users, TrendingUp, Activity, AlertCircle, CheckCircle, Clock, Edit, Copy, Trash2, Plus, Filter, Download, Eye, BarChart3, Workflow } from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const AutomatizareRPA = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showWorkflowModal, setShowWorkflowModal] = useState(false);
  const [selectedWorkflow, setSelectedWorkflow] = useState(null);
  const [filterStatus, setFilterStatus] = useState('Toate');
  const [filterCategory, setFilterCategory] = useState('Toate');

  // Mock data pentru RPA workflows
  const rpaData = {
    overview: {
      totalWorkflows: 24,
      activeWorkflows: 18,
      savedHours: '1,240 ore',
      monthlyExecutions: 15678
    },
    performance: {
      successRate: 96.8,
      averageExecutionTime: '2.3 min',
      errorRate: 3.2,
      costSavings: '45,600 RON'
    },
    workflows: [
      {
        id: 1,
        name: 'Procesare Facturi Furnizori',
        category: 'Contabilitate',
        status: 'Activ',
        trigger: 'Email cu factura',
        frequency: 'La cerere',
        lastRun: '2024-03-15 14:30',
        nextRun: 'La următorul email',
        executions: 1247,
        successRate: 98.2,
        averageTime: '45 sec',
        description: 'Automatizare completă procesare facturi: extragere date, validare, înregistrare în sistem',
        steps: [
          'Monitorizare inbox email pentru facturi',
          'Extragere date cu OCR',
          'Validare furnizor în baza de date',
          'Calcul TVA și verificare sume',
          'Creare înregistrare contabilă',
          'Trimitere notificare aprobare'
        ],
        createdAt: '2024-02-10',
        createdBy: 'Ana Popescu',
        savings: '8,500 RON/lună'
      },
      {
        id: 2,
        name: 'Onboarding Angajați Noi',
        category: 'HR',
        status: 'Activ',
        trigger: 'Contract semnat',
        frequency: 'La eveniment',
        lastRun: '2024-03-14 10:15',
        nextRun: 'La următorul angajat',
        executions: 89,
        successRate: 95.5,
        averageTime: '15 min',
        description: 'Proces automat onboarding: creare conturi, trimitere documente, planificare training',
        steps: [
          'Creare cont utilizator Active Directory',
          'Generare email corporativ',
          'Trimitere welcome package',
          'Programare sesiune orientare',
          'Creare task-uri pentru manager',
          'Actualizare organigramă'
        ],
        createdAt: '2024-01-20',
        createdBy: 'Mihai Ionescu',
        savings: '12 ore/angajat nou'
      },
      {
        id: 3,
        name: 'Sincronizare Date CRM-ERP',
        category: 'Integrare',
        status: 'Activ',
        trigger: 'Schedule',
        frequency: 'În fiecare oră',
        lastRun: '2024-03-15 15:00',
        nextRun: '2024-03-15 16:00',
        executions: 8760,
        successRate: 99.1,
        averageTime: '3 min',
        description: 'Sincronizare automată date între CRM și ERP: clienți, comenzi, stocuri',
        steps: [
          'Conectare la CRM API',
          'Extragere date modificate',
          'Transformare format date',
          'Validare integritate',
          'Import în ERP',
          'Log reconciliere'
        ],
        createdAt: '2024-01-05',
        createdBy: 'System Admin',
        savings: '160 ore/lună'
      },
      {
        id: 4,
        name: 'Raportare Vânzări Zilnică',
        category: 'Sales',
        status: 'Pauză',
        trigger: 'Schedule',
        frequency: 'Zilnic la 18:00',
        lastRun: '2024-03-10 18:00',
        nextRun: 'Dezactivat',
        executions: 156,
        successRate: 92.3,
        averageTime: '8 min',
        description: 'Generare și distribuire automată rapoarte zilnice de vânzări către management',
        steps: [
          'Colectare date vânzări din multiple surse',
          'Calcul KPI-uri și metrici',
          'Generare grafice și tabele',
          'Creare raport PDF',
          'Distribuire email către stakeholderi',
          'Salvare în arhiva rapoarte'
        ],
        createdAt: '2024-02-01',
        createdBy: 'Laura Sales',
        savings: '2 ore/zi'
      },
      {
        id: 5,
        name: 'Backup Automat Date Critice',
        category: 'IT',
        status: 'Activ',
        trigger: 'Schedule',
        frequency: 'Zilnic la 02:00',
        lastRun: '2024-03-15 02:00',
        nextRun: '2024-03-16 02:00',
        executions: 445,
        successRate: 99.8,
        averageTime: '25 min',
        description: 'Backup automat al bazelor de date și fișierelor critice cu verificare integritate',
        steps: [
          'Oprire temporară servicii non-critice',
          'Backup bazele de date',
          'Backup fișiere aplicații',
          'Compresia arhivelor',
          'Upload în cloud storage',
          'Verificare integritate backup-uri'
        ],
        createdAt: '2023-12-15',
        createdBy: 'IT Admin',
        savings: '4 ore/zi'
      },
      {
        id: 6,
        name: 'Procesare Cereri Concediu',
        category: 'HR',
        status: 'În dezvoltare',
        trigger: 'Formular completat',
        frequency: 'La cerere',
        lastRun: null,
        nextRun: 'În testare',
        executions: 0,
        successRate: 0,
        averageTime: 'N/A',
        description: 'Workflow automat pentru procesarea și aprobarea cererilor de concediu',
        steps: [
          'Validare balanță concedii',
          'Verificare overlap echipă',
          'Notificare manager direct',
          'Procesul de aprobare',
          'Actualizare calendar',
          'Notificare HR și angajat'
        ],
        createdAt: '2024-03-01',
        createdBy: 'Maria HR',
        savings: 'Estimat: 30 min/cerere'
      }
    ],
    categories: [
      { name: 'Contabilitate', count: 6, activeCount: 5, savings: '25,400 RON' },
      { name: 'HR', count: 4, activeCount: 3, savings: '18,200 RON' },
      { name: 'Sales', count: 5, activeCount: 3, savings: '12,800 RON' },
      { name: 'IT', count: 7, activeCount: 6, savings: '22,600 RON' },
      { name: 'Integrare', count: 2, activeCount: 2, savings: '8,900 RON' }
    ],
    executionHistory: [
      { date: '2024-03-15', executions: 1247, successes: 1203, failures: 44, totalTime: '8.2 ore' },
      { date: '2024-03-14', executions: 1156, successes: 1098, failures: 58, totalTime: '7.8 ore' },
      { date: '2024-03-13', executions: 1089, successes: 1034, failures: 55, totalTime: '7.3 ore' },
      { date: '2024-03-12', executions: 967, successes: 912, failures: 55, totalTime: '6.9 ore' },
      { date: '2024-03-11', executions: 1234, successes: 1187, failures: 47, totalTime: '8.1 ore' }
    ],
    triggers: [
      { type: 'Schedule', count: 12, description: 'Workflows care rulează pe bază de programare' },
      { type: 'Email', count: 6, description: 'Declanșate la primirea de email-uri specifice' },
      { type: 'File Upload', count: 3, description: 'Activate la încărcarea de fișiere' },
      { type: 'API Call', count: 2, description: 'Invocate prin API externa' },
      { type: 'Manual', count: 1, description: 'Rulate manual de către utilizatori' }
    ]
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Activ': return 'success';
      case 'Pauză': return 'warning';
      case 'În dezvoltare': return 'info';
      case 'Eroare': return 'error';
      default: return 'default';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Contabilitate': return 'info';
      case 'HR': return 'success';
      case 'Sales': return 'warning';
      case 'IT': return 'error';
      case 'Integrare': return 'default';
      default: return 'default';
    }
  };

  const getSuccessRateColor = (rate) => {
    if (rate >= 95) return 'text-green-600';
    if (rate >= 90) return 'text-blue-600';
    if (rate >= 85) return 'text-yellow-600';
    return 'text-red-600';
  };

  // Filtrarea workflow-urilor
  const filteredWorkflows = rpaData.workflows.filter(workflow => {
    const matchesStatus = filterStatus === 'Toate' || workflow.status === filterStatus;
    const matchesCategory = filterCategory === 'Toate' || workflow.category === filterCategory;
    return matchesStatus && matchesCategory;
  });

  const workflowColumns = [
    { 
      header: 'Workflow', 
      key: 'name',
      render: (value, row) => (
        <div>
          <div className="font-medium text-gray-900 dark:text-white">{value}</div>
          <div className="text-sm text-gray-500">{row.description}</div>
        </div>
      )
    },
    { 
      header: 'Categorie', 
      key: 'category',
      render: (value) => <Badge variant={getCategoryColor(value)}>{value}</Badge>
    },
    { 
      header: 'Status', 
      key: 'status',
      render: (value) => <Badge variant={getStatusColor(value)}>{value}</Badge>
    },
    { 
      header: 'Execuții', 
      key: 'executions',
      render: (value) => <span className="font-semibold text-primary-600">{value.toLocaleString('ro-RO')}</span>
    },
    { 
      header: 'Success Rate', 
      key: 'successRate',
      render: (value) => (
        <div className="flex items-center space-x-2">
          <div className={`font-semibold ${getSuccessRateColor(value)}`}>{value}%</div>
          <div className="w-12 bg-gray-200 dark:bg-gray-700 rounded-full h-1">
            <div 
              className={`h-1 rounded-full ${
                value >= 95 ? 'bg-green-500' : 
                value >= 90 ? 'bg-blue-500' : 
                value >= 85 ? 'bg-yellow-500' : 'bg-red-500'
              }`}
              style={{ width: `${value}%` }}
            ></div>
          </div>
        </div>
      )
    },
    { 
      header: 'Timp Mediu', 
      key: 'averageTime'
    },
    { 
      header: 'Economii', 
      key: 'savings',
      render: (value) => <span className="font-bold text-green-600">{value}</span>
    },
    {
      header: 'Acțiuni',
      key: 'actions',
      render: (_, row) => (
        <div className="flex space-x-1">
          <button
            onClick={() => {
              setSelectedWorkflow(row);
              setShowWorkflowModal(true);
            }}
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          {row.status === 'Activ' ? (
            <button
              className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-red-500"
              title="Pauză"
            >
              <Pause className="w-4 h-4" />
            </button>
          ) : (
            <button
              className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-green-500"
              title="Start"
            >
              <Play className="w-4 h-4" />
            </button>
          )}
          <button
            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded text-blue-500"
            title="Editează"
          >
            <Edit className="w-4 h-4" />
          </button>
        </div>
      )
    }
  ];

  const historyColumns = [
    { header: 'Data', key: 'date' },
    { header: 'Total Execuții', key: 'executions' },
    { header: 'Succese', key: 'successes', render: (value) => <span className="text-green-600 font-medium">{value}</span> },
    { header: 'Eșecuri', key: 'failures', render: (value) => <span className="text-red-600 font-medium">{value}</span> },
    { header: 'Timp Total', key: 'totalTime' }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Automatizare RPA</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            Robotic Process Automation pentru taskuri repetitive și workflow-uri complexe
          </p>
        </div>
        <div className="flex space-x-3">
          <button className="btn-secondary">
            <Download className="w-4 h-4 mr-2" />
            Export Raport
          </button>
          <button className="btn-secondary">
            <Settings className="w-4 h-4 mr-2" />
            Configurări
          </button>
          <button 
            className="btn-primary"
            onClick={() => setShowCreateModal(true)}
          >
            <Plus className="w-4 h-4 mr-2" />
            Workflow Nou
          </button>
        </div>
      </div>

      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card title="Total Workflows" subtitle="Toate sistemele" icon={Bot}>
          <div className="text-2xl font-bold text-primary-600">{rpaData.overview.totalWorkflows}</div>
          <div className="text-sm text-blue-600">{rpaData.overview.activeWorkflows} active</div>
        </Card>
        <Card title="Ore Economisire" subtitle="Luna aceasta" icon={Clock}>
          <div className="text-2xl font-bold text-primary-600">{rpaData.overview.savedHours}</div>
          <div className="text-sm text-green-600">+18% față de luna trecută</div>
        </Card>
        <Card title="Execuții" subtitle="Luna aceasta" icon={Activity}>
          <div className="text-2xl font-bold text-primary-600">{rpaData.overview.monthlyExecutions.toLocaleString('ro-RO')}</div>
          <div className="text-sm text-green-600">Medie: 506/zi</div>
        </Card>
        <Card title="Economii Cost" subtitle="Luna aceasta" icon={TrendingUp}>
          <div className="text-2xl font-bold text-primary-600">{rpaData.performance.costSavings}</div>
          <div className="text-sm text-green-600">ROI: 340%</div>
        </Card>
      </div>

      {/* Performance Metrics */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card title="Success Rate" subtitle="Mediu general" icon={CheckCircle}>
          <div className="text-xl font-bold text-green-600">{rpaData.performance.successRate}%</div>
        </Card>
        <Card title="Timp Execuție" subtitle="Mediu per workflow" icon={Clock}>
          <div className="text-xl font-bold text-primary-600">{rpaData.performance.averageExecutionTime}</div>
        </Card>
        <Card title="Error Rate" subtitle="Procent eșecuri" icon={AlertCircle}>
          <div className="text-xl font-bold text-red-600">{rpaData.performance.errorRate}%</div>
        </Card>
        <Card title="Workflows Active" subtitle="În execuție" icon={Play}>
          <div className="text-xl font-bold text-primary-600">{rpaData.overview.activeWorkflows}</div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Workflows Table */}
        <div className="lg:col-span-2">
          <Card title="Workflow-uri RPA" subtitle="Automatizări active și în dezvoltare">
            <div className="mb-4 flex items-center space-x-4">
              <select 
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white text-sm"
              >
                <option>Toate</option>
                <option>Activ</option>
                <option>Pauză</option>
                <option>În dezvoltare</option>
                <option>Eroare</option>
              </select>
              
              <select 
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white text-sm"
              >
                <option>Toate</option>
                <option>Contabilitate</option>
                <option>HR</option>
                <option>Sales</option>
                <option>IT</option>
                <option>Integrare</option>
              </select>

              <button className="btn-secondary btn-sm">
                <Filter className="w-3 h-3 mr-1" />
                Filtre
              </button>
            </div>

            <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
              Afișez {filteredWorkflows.length} din {rpaData.workflows.length} workflow-uri
            </div>

            <Table columns={workflowColumns} data={filteredWorkflows} />
          </Card>
        </div>

        {/* Sidebar */}
        <div className="space-y-6">
          <Card title="Categorii Workflow" icon={BarChart3}>
            <div className="space-y-4">
              {rpaData.categories.map((category, index) => (
                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                  <div>
                    <div className="font-medium text-sm text-gray-900 dark:text-white">
                      {category.name}
                    </div>
                    <div className="text-xs text-gray-500">
                      {category.activeCount}/{category.count} active
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm font-semibold text-green-600">{category.savings}</div>
                    <div className="text-xs text-gray-500">economii/lună</div>
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card title="Trigger Types" icon={Zap}>
            <div className="space-y-3">
              {rpaData.triggers.map((trigger, index) => (
                <div key={index} className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                  <div className="flex items-center justify-between mb-1">
                    <div className="font-medium text-sm text-gray-900 dark:text-white">
                      {trigger.type}
                    </div>
                    <span className="text-xs text-gray-500">{trigger.count} workflows</span>
                  </div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">
                    {trigger.description}
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card title="Acțiuni Rapide" icon={Workflow}>
            <div className="space-y-3">
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Rulează Toate Workflow-urile</span>
                  <Play className="w-4 h-4 text-gray-400" />
                </div>
              </button>
              
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Backup Configurări</span>
                  <Download className="w-4 h-4 text-gray-400" />
                </div>
              </button>
              
              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Monitor Sistem</span>
                  <Activity className="w-4 h-4 text-gray-400" />
                </div>
              </button>

              <button className="w-full text-left p-3 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">Raport Performanță</span>
                  <BarChart3 className="w-4 h-4 text-gray-400" />
                </div>
              </button>
            </div>
          </Card>
        </div>
      </div>

      {/* Execution History */}
      <Card title="Istoricul Execuțiilor" subtitle="Performanța workflow-urilor în ultimele 5 zile">
        <Table columns={historyColumns} data={rpaData.executionHistory} />
      </Card>

      {/* Create Workflow Modal */}
      <Modal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        title="Creează Workflow RPA Nou"
        size="large"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Numele Workflow-ului
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
                placeholder="Ex: Procesare Comenzi Automate"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Categorie
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white">
                <option>Selectează categorie...</option>
                <option>Contabilitate</option>
                <option>HR</option>
                <option>Sales</option>
                <option>Marketing</option>
                <option>IT</option>
                <option>Integrare</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Descriere Workflow
            </label>
            <textarea
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              placeholder="Descrie ce automatizează acest workflow..."
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Tip Trigger
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white">
                <option>Schedule (Programat)</option>
                <option>Email (La primirea email)</option>
                <option>File Upload (La încărcare fișier)</option>
                <option>API Call (Prin API)</option>
                <option>Manual (Rulare manuală)</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Frecvența
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700 dark:text-white">
                <option>La cerere</option>
                <option>În fiecare oră</option>
                <option>Zilnic</option>
                <option>Săptămânal</option>
                <option>Lunar</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Pași Workflow (câte unul pe linie)
            </label>
            <textarea
              rows="6"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
              placeholder="1. Primul pas al automatizării&#10;2. Al doilea pas&#10;3. Al treilea pas&#10;..."
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" defaultChecked />
                <span className="text-sm">Notificare la finalizare</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Retry automat la eșec</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" defaultChecked />
                <span className="text-sm">Log detaliat execuție</span>
              </label>
            </div>
            <div className="space-y-2">
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Timeout personalizat</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Validare pre-execuție</span>
              </label>
              <label className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" />
                <span className="text-sm">Backup date înainte</span>
              </label>
            </div>
          </div>

          <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
            <div className="flex items-center space-x-2 mb-2">
              <Bot className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-medium text-blue-800 dark:text-blue-200">AI Workflow Builder</span>
            </div>
            <div className="text-sm text-blue-700 dark:text-blue-300">
              Workflow-ul va fi optimizat automat de AI pentru eficiență maximă. Estimăm o economie de timp de
              60-80% față de procesarea manuală și o rată de succes de peste 95%.
            </div>
          </div>

          <div className="flex justify-end space-x-3">
            <button 
              className="btn-secondary"
              onClick={() => setShowCreateModal(false)}
            >
              Anulează
            </button>
            <button className="btn-secondary">
              Salvează ca Draft
            </button>
            <button className="btn-primary">
              <Bot className="w-4 h-4 mr-2" />
              Creează Workflow
            </button>
          </div>
        </div>
      </Modal>

      {/* Workflow Details Modal */}
      <Modal
        isOpen={showWorkflowModal}
        onClose={() => {
          setShowWorkflowModal(false);
          setSelectedWorkflow(null);
        }}
        title={`Detalii Workflow: ${selectedWorkflow?.name || ''}`}
        size="large"
      >
        {selectedWorkflow && (
          <div className="space-y-6">
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Generale</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Categorie:</span>
                    <Badge variant={getCategoryColor(selectedWorkflow.category)}>{selectedWorkflow.category}</Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Status:</span>
                    <Badge variant={getStatusColor(selectedWorkflow.status)}>{selectedWorkflow.status}</Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Trigger:</span>
                    <span>{selectedWorkflow.trigger}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Frecvența:</span>
                    <span>{selectedWorkflow.frequency}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Creat la:</span>
                    <span>{selectedWorkflow.createdAt}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Creat de:</span>
                    <span>{selectedWorkflow.createdBy}</span>
                  </div>
                </div>
              </div>
              
              <div>
                <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Performanță</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Execuții totale:</span>
                    <span className="font-medium">{selectedWorkflow.executions.toLocaleString('ro-RO')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Success Rate:</span>
                    <span className={`font-medium ${getSuccessRateColor(selectedWorkflow.successRate)}`}>
                      {selectedWorkflow.successRate}%
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Timp mediu:</span>
                    <span>{selectedWorkflow.averageTime}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Ultima rulare:</span>
                    <span>{selectedWorkflow.lastRun || 'N/A'}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Următoarea:</span>
                    <span>{selectedWorkflow.nextRun}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Economii:</span>
                    <span className="font-bold text-green-600">{selectedWorkflow.savings}</span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Descriere</h4>
              <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  {selectedWorkflow.description}
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-gray-900 dark:text-white mb-3">Pași Workflow</h4>
              <div className="space-y-2">
                {selectedWorkflow.steps.map((step, index) => (
                  <div key={index} className="flex items-start space-x-3 p-2 bg-gray-50 dark:bg-gray-700 rounded-lg">
                    <div className="flex-shrink-0 w-6 h-6 bg-primary-500 text-white rounded-full flex items-center justify-center text-xs font-medium">
                      {index + 1}
                    </div>
                    <span className="text-sm text-gray-700 dark:text-gray-300">{step}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
              <div className="flex items-center space-x-2 mb-2">
                <CheckCircle className="w-4 h-4 text-green-600" />
                <span className="text-sm font-medium text-green-800 dark:text-green-200">Impact Economii</span>
              </div>
              <div className="text-sm text-green-700 dark:text-green-300">
                Acest workflow economisește <strong>{selectedWorkflow.savings}</strong> prin automatizare.
                Cu o rată de succes de {selectedWorkflow.successRate}%, reprezintă o investiție foarte profitabilă în eficiența proceselor.
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button className="btn-secondary">
                <Copy className="w-4 h-4 mr-2" />
                Duplică
              </button>
              <button className="btn-secondary">
                <Edit className="w-4 h-4 mr-2" />
                Editează
              </button>
              {selectedWorkflow.status === 'Activ' ? (
                <button className="btn-secondary bg-red-50 text-red-600 hover:bg-red-100">
                  <Pause className="w-4 h-4 mr-2" />
                  Pauză
                </button>
              ) : (
                <button className="btn-secondary bg-green-50 text-green-600 hover:bg-green-100">
                  <Play className="w-4 h-4 mr-2" />
                  Start
                </button>
              )}
              <button 
                className="btn-primary"
                onClick={() => {
                  setShowWorkflowModal(false);
                  setSelectedWorkflow(null);
                }}
              >
                Închide
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default AutomatizareRPA;
